import React from 'react'
import { Button,Dropdown } from 'antd'

const items = [
    {
        key: '1',
        label : (
            <a href="https://www.youtube.com/watch?v=QsOPzhSMC4I">1-video ma'ruza</a>
        )
    },
    {
        key: '2',
        label : (
            <a href="https://www.youtube.com/watch?v=rYq0J9pZc34">2-video ma'ruza</a>
        )
    },
    {
        key: '3',
        label : (
            <a href="https://www.youtube.com/watch?v=gKk0yF-A7BY">3-video ma'ruza</a>
        )
    },
    {
        key: '4',
        label : (
            <a href="https://www.youtube.com/watch?v=8PzZz3K0Onw">4-video ma'ruza</a>
        )
    },
    {
        key: '5',
        label : (
            <a href="https://www.youtube.com/watch?v=pa0FO2IKW-c">5-video ma'ruza</a>
        )
    },
    {
        key: '6',
        label : (
            <a href="https://www.youtube.com/watch?v=PJBUyICriIU">6-video ma'ruza</a>
        )
    },
    {
        key: '7',
        label : (
            <a href="https://www.youtube.com/watch?v=jay8uTJNej8">7-video ma'ruza</a>
        )
    },
    {
        key: '8',
        label : (
            <a href="https://www.youtube.com/watch?v=UVFhZKBN2Wg">8-video ma'ruza</a>
        )
    },
    {
        key: '9',
        label : (
            <a href="https://www.youtube.com/watch?v=aJPYMf4r6eU">9-video ma'ruza</a>
        )
    },
    {
        key: '10',
        label : (
            <a href="https://www.youtube.com/watch?v=74uTERtC5V0">10-video ma'ruza</a>
        )
    },
    {
        key: '11',
        label : (
            <a href="https://www.youtube.com/watch?v=wTM1nhpeBHk">11-video ma'ruza</a>
        )
    },
    {
        key: '12',
        label : (
            <a href="https://www.youtube.com/watch?v=NNhmHyHA9VM">12-video ma'ruza</a>
        )
    },
    {
        key: '13',
        label : (
            <a href="https://www.youtube.com/watch?v=YdNQgMjva4o">13-video ma'ruza</a>
        )
    },
    {
        key: '14',
        label : (
            <a href="https://www.youtube.com/watch?v=3voL6o4mgaQ">14-video ma'ruza</a>
        )
    },
    {
        key: '15',
        label : (
            <a href="https://www.youtube.com/watch?v=G4TVnJJrQ8Q">15-video ma'ruza</a>
        )
    },
]

const Ilovalar = () => {
  return (
    <div>
        <Dropdown menu={{items}} placement='bottom' arrow={{pointAtCenter: true}}>
        <Button className='button'>
            Ilovalar
        </Button>
        </Dropdown>
    </div>
  )
}

export default Ilovalar